import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getDossierDetailsFleet, getDossierDetailsFleetSuccess, fetchPaymentCombo, deleteDossiersFromFleet, getFleetOperations } from '../../../../actions/management/management'
import { openModal } from '../../../../actions/common'
import { openAddDossiersToFleetModal, openChargeDossiersModal } from '../../../../actions/management/auxModals/auxModals'
import { fetchVehicleType } from '../../../../actions/combos/combos'
import DossiersListFleetDetailsComponent from '../../../../components/management/fleets/dossiers/DossiersListFleetDetailsComponent'

export function mapStateToProps (state) {
  return {
    dossierFleetDetails: state.management.dossierFleetDetails,
    combos: state.combos,
    operationActions: state.management.operateFleetModal.operationActions,
    dataActions: state.management.operateFleetModal.dataActions
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openModal,
      getDossierDetailsFleet,
      getDossierDetailsFleetSuccess,
      openAddDossiersToFleetModal,
      fetchPaymentCombo,
      fetchVehicleType,
      openChargeDossiersModal,
      deleteDossiersFromFleet,
      getFleetOperations
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(DossiersListFleetDetailsComponent))
